import { render, staticRenderFns } from "./customerList_qy.vue?vue&type=template&id=5ccf0392&scoped=true&"
import script from "./customerList_qy.vue?vue&type=script&lang=js&"
export * from "./customerList_qy.vue?vue&type=script&lang=js&"
import style0 from "./customerList_qy.vue?vue&type=style&index=0&id=5ccf0392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf0392",
  null
  
)

export default component.exports